import React, { useEffect, useState } from "react";
import * as url from "../../../../helpers/url_helper";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ConfirmationModal from "../../../../components/Common/ConfirmationModal";
import axios from "axios";
import ChipsDataTable from "./ChipsDetail/ChipsDataTable";
import {
  AssignIcon,
  DeleteIcon,
  MqttIcon,
  OtaIcon,
  PingIcon,
} from "../../../../assets/svg";
import { ActionButton } from "../../../../components/Common/button";
import AssignRoomModal from "./AssignRoomModal";
import OtaMultiModel from "./OtaMultiModel";
import { OPERATE_MQTT } from "../../../../helpers/socketEvent";
import { useSocket } from "../../../../Utils/socket";
import OtaModel from "./OtaModal";

export interface LockControlProps {
  userId: any;
  selectedPremise?: any;
}

function CurtainList({ userId }: LockControlProps) {
  const selectedRooms = useSelector(
    (state: any) => state.APIResponse.selectedRooms,
  );
  const token = localStorage.getItem("Authorization");
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  const socket: any = useSocket();

  const [isMultiDeleteModalOpen, setMultiDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();
  const [isReload, setReload] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [assignData, setAssignData] = useState<any>({});
  const [isAssignRoomModalOpen, setIsAssignRoomModalOpen] = useState(false);
  const [isMultiOtaModalOpen, setIsMultiOtaModalOpen] = useState(false);
  const [isOtaModalOpen, setIsOtaModalOpen] = useState(false);
  const [otaSlave, setOtaSlave] = useState<any>({});

  const columns = [
    {
      name: "Slave",
      selector: (row: any) => row.slave || "-",
      sortable: true,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Name",
      selector: (row: any) => row.name || "-",
      sortable: true,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Room",
      selector: (row: any) => row.roomName || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "HW-V",
      selector: (row: any) => row.hwVersion || "-",
      sortable: true,
    },
    {
      name: "WI-V",
      selector: (row: any) => row.wifiVersion || "-",
      sortable: true,
    },

    {
      name: "Model",
      selector: (row: any) => row.modelType || "-",
      sortable: true,
    },
    {
      name: "Auto Power",
      selector: (row: any) => (row.autoPower ? "ON" : "OFF"),
      sortable: true,
    },
    {
      name: "Direction",
      selector: (row: any) => row.motorDirection || "-",
      sortable: true,
    },

    {
      name: "Status",
      selector: (row: any) => (row.isOnline ? "Online" : "Offline"),
      cell: (row: any) =>
        row.isOnline === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            online
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            Offline
          </span>
        ),
      sortable: true,
    },
    {
      name: "Signal",
      selector: (row: any) => (row.signalStrength ? row.signalStrength : 0),
      cell: (row: any) => (
        <div>
          <span style={{ fontWeight: "bold", color: "black" }}>
            {row.signalStrength || "-"}
          </span>{" "}
          ({row.ssid || "-"})
        </div>
      ),
      sortable: true,
      grow: 1.5,
      wrap: true,
    },

    {
      name: "Actions",
      grow: 2,
      cell: (row: any) => (
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          <ActionButton
            id="DeleteIconButton"
            title="Delete"
            icon={<DeleteIcon />}
            onClick={() => handleDeleteClick(row)}
          />
          <ActionButton
            id="PingIconButton"
            title="Ping"
            icon={<PingIcon />}
            onClick={() => handlePingClick(row)}
          />
          <ActionButton
            id="OTAIconButton"
            title="OTA"
            icon={<OtaIcon />}
            onClick={() => handleOtaClick(row)}
          />
          <ActionButton
            id="MQTTLogsIconButton"
            title="MQTT Logs"
            icon={<MqttIcon />}
            onClick={() => handleMQTTData(row)}
          />
          <ActionButton
            id="AssignIconButton"
            title="Assign Room"
            icon={<AssignIcon />}
            onClick={() => handleAssignClick(row)}
          />
        </div>
      ),
    },
  ];

  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const handleAssignClick = (row: any) => {
    if (row !== undefined) {
      setIsAssignRoomModalOpen(!isAssignRoomModalOpen);
      setAssignData(row);
    }
  };
  const deleteLockApiCall = () => {
    setLoading(true);
    const reqObj = {
      airCurtainId: deleteData.id,
    };

    axios
      .delete(`${url.BASE_URL}${url.DELETE_CURTAIN}`, {
        data: reqObj,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.msg);
        handleRefresh();
        setDeleteModalOpen(false);
        setDeleteData(null);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleDeleteClick = (rowData: any) => {
    setDeleteModalOpen(!isDeleteModalOpen);
    setDeleteData(rowData);
  };
  const multiDeleteLockApiCall = () => {
    setLoading(true);
    const reqObj = {
      airCurtainId: selectedRows?.map((item) => item._id),
    };

    axios
      .delete(`${url.BASE_URL}${url.DELETE_CURTAIN}`, {
        data: reqObj,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.msg);
        handleRefresh();
        setMultiDeleteModalOpen(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const handleDeleteAll = () => {
    setMultiDeleteModalOpen(!isMultiDeleteModalOpen);
  };
  const handleMQTTData = (rowData: any) => {
    rowData?.slave
      ? window.open(`/debug-device-details/${rowData?.slave}`, "_blank")
      : "";
  };
  const handlePingClick = (row: any) => {
    if (row !== undefined) {
      const reqObj = {
        slave: row?.slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "PG",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`Ping sent to slave ${row?.slave}`);
    }
  };
  const handleOtaAll = () => {
    if (selectedRows.length > 0) {
      setIsMultiOtaModalOpen(!isMultiOtaModalOpen);
    }
  };
  const handlePingAll = () => {
    if (selectedRows.length > 0) {
      selectedRows?.forEach((item) => {
        const reqObj = {
          slave: item.slave,
          tag: `airpanel-${userInfo?.id}`,
          cmd: "PG",
        };
        socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      });
      handleRefresh();
      toast.success(
        `Ping successfully sent to ${selectedRows?.length} slaves.`,
      );
    }
  };
  const handleDsAll = () => {
    if (selectedRows.length > 0) {
      selectedRows?.forEach((item) => {
        const reqObj = {
          slave: item.slave,
          tag: `airpanel-${userInfo?.id}`,
          cmd: "DS",
        };
        socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      });
      handleRefresh();
      toast.success(`DS successfully sent to ${selectedRows?.length} slaves.`);
    }
  };
  const handleOtaClick = (row: any) => {
    if (row !== undefined) {
      setIsOtaModalOpen(!isOtaModalOpen);
      setOtaSlave(row);
    }
  };

  return (
    <div>
      {isDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete Curtain?"
          text="Are you sure you want to delete this Curtain ? This action cannot be undone."
          buttonText="Delete"
          onClick={() => {
            deleteLockApiCall();
          }}
          cancleBtnClick={() => setDeleteModalOpen(false)}
          loading={loading}
        />
      )}
      {isMultiDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete Curtain?"
          text="Are you sure you want to delete this Curtain ? This action cannot be undone."
          buttonText="Delete"
          onClick={() => {
            multiDeleteLockApiCall();
          }}
          cancleBtnClick={() => setMultiDeleteModalOpen(false)}
          loading={loading}
        />
      )}
      {isAssignRoomModalOpen && (
        <AssignRoomModal
          headerTitle="Assign Room"
          idName={"Curtainlist"}
          assignData={assignData}
          handleRefresh={handleRefresh}
          cancleBtnClick={() => {
            setIsAssignRoomModalOpen(false);
            setAssignData({});
          }}
        />
      )}
      {isMultiOtaModalOpen && (
        <OtaMultiModel
          headerTitle="SELECTED OTA"
          // selectedRows={selectedRows}
          selectedRows={selectedRows.map((item: any) => ({
            ...item,
            product: item?.product ? item.product.toLowerCase() : item.product,
          }))}
          cancleBtnClick={() => setIsMultiOtaModalOpen(false)}
        />
      )}
      {isOtaModalOpen && (
        <OtaModel
          headerTitle="OTA"
          // otaSlave={otaSlave}
          otaSlave={{
            ...otaSlave,
            product: otaSlave.product.toLowerCase() || otaSlave?.product,
          }}
          cancleBtnClick={() => setIsOtaModalOpen(false)}
        />
      )}
      <ChipsDataTable
        apiURL={`${url.BASE_URL}${url.GET_CURTAIN_LIST}`}
        title="Curtain List"
        customStyles={customStyles}
        selectedRoomID={selectedRooms}
        columns={columns}
        isReload={isReload}
        idName={"Curtainlist"}
        loading={loading}
        setLoading={setLoading}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        userId={userId}
        expandableRows={false}
        ExpandCollapseIcon={ExpandCollapseIcon}
        handleDeleteAll={handleDeleteAll}
        handleOtaAll={handleOtaAll}
        handlePingAll={handlePingAll}
        handleDsAll={handleDsAll}
      />
    </div>
  );
}

export default CurtainList;

export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
      padding: "0px !important",
    },
  },
  headCells: {
    style: {
      padding: "0px 2px",
      margin: "0px",
    },
  },

  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
      padding: "0px 2px !important",
    },
  },
};

export const ExpandCollapseIcon = ({ expanded }: { expanded: boolean }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center  "
      style={{ cursor: "pointer", width: "32px", height: "32px" }}
    >
      <i
        className={`bx ${
          expanded ? "bx-caret-down" : "bx-caret-right"
        } text-dark fs-5`}
      ></i>
    </div>
  );
};
